module.exports = __webpack_public_path__ + "static/media/page1.42456fb8.png";